import { render, staticRenderFns } from "./dogovor.vue?vue&type=template&id=2965be45&scoped=true&"
import script from "./dogovor.vue?vue&type=script&lang=js&"
export * from "./dogovor.vue?vue&type=script&lang=js&"
import style0 from "./dogovor.vue?vue&type=style&index=0&id=2965be45&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965be45",
  null
  
)

export default component.exports